import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SelectBlock from '../../../components/SelectBlock';
import Constants from '../../../../constants/constants';

const clientSections = [
  {
    key: 'general-information',
    label: 'General Information',
    matches: ['general-information'],
  },
  {
    key: 'locations',
    label: 'Locations',
    matches: ['locations', 'client-location'],
  },
  {
    key: 'jobs',
    label: 'Projects',
    matches: ['jobs'],
  },
  {
    key: 'invoices',
    label: 'Invoices',
    matches: [],
    isDisabled: true,
  },
];

const ClientMobileNavigation = ({ clientId, clientProfile }) => {
  const history = useHistory();
  const location = useLocation();
  const currentSection =
    clientSections.find((section) => section.matches.some((path) => location.pathname.includes(`/client-detail/${path}/`))) ||
    clientSections[0];
  const sectionOptions = clientSections.map((section) => ({
    value: section.key,
    label: section.label,
    isDisabled: section.isDisabled,
  }));
  const selectedSection = sectionOptions.find((option) => option.value === currentSection.key);

  const navigateToSection = (selectedOption) => {
    if (selectedOption && !selectedOption.isDisabled) {
      history.push(`/management/client-detail/${selectedOption.value}/${clientId}`);
    }
  };

  return (
    <section className='aes-client-mobile-navigation d-lg-none' aria-labelledby='aes-client-mobile-navigation-title'>
      <div className='aes-client-mobile-navigation__summary'>
        <div className='aes-client-mobile-navigation__identity'>
          {clientProfile.imageUrl && (
            <div className='aes-client-mobile-navigation__avatar symbol symbol-50'>
              <div
                className='symbol-label background-image-container'
                style={{ backgroundImage: `url(${Constants.API_URL + clientProfile.imageUrl})` }}
                aria-hidden='true'
              />
            </div>
          )}
          <div className='aes-client-mobile-navigation__name'>
            <span className='aes-client-mobile-navigation__eyebrow'>Client Profile</span>
            <h2 id='aes-client-mobile-navigation-title' className='font-size-h2 font-weight-boldest'>
              {clientProfile.name || 'Client'}
            </h2>
          </div>
        </div>
      </div>

      <div className='aes-client-mobile-navigation__details'>
        {clientProfile.email && (
          <div className='aes-client-mobile-navigation__detail'>
            <span>Email</span>
            <strong>{clientProfile.email}</strong>
          </div>
        )}
        {clientProfile.primaryPhone && (
          <div className='aes-client-mobile-navigation__detail'>
            <span>Phone</span>
            <strong>{clientProfile.primaryPhone}</strong>
          </div>
        )}
        {clientProfile.location && (
          <div className='aes-client-mobile-navigation__detail'>
            <span>Location</span>
            <strong>{clientProfile.location}</strong>
          </div>
        )}
      </div>

      <SelectBlock
        label='Current section'
        className='aes-client-mobile-navigation__select'
        selectClassNamePrefix='aes-client-navigation-select'
        containerClassName='aes-client-mobile-navigation__select-container'
        options={sectionOptions}
        value={selectedSection}
        onChange={navigateToSection}
        isSearchable={false}
        menuPortalTarget={document.body}
        menuPosition='fixed'
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 1060 }),
        }}
      />
    </section>
  );
};

export default ClientMobileNavigation;
